module.exports = __webpack_public_path__ + "img/i3.9cff9731.jpg";